import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../http.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public is_loading: boolean = false;
  public user: { username?: string, password?: string } = {};

  // Color switcher
  public showColorPicker = false;
  public themeColors = [
    { name: 'Blue',    color: '0,123,255',   text: '#fff' },
    { name: 'Indigo',  color: '99,102,241',  text: '#fff' },
    { name: 'Purple',  color: '139,92,246',  text: '#fff' },
    { name: 'Pink',    color: '236,72,153',  text: '#fff' },
    { name: 'Red',     color: '239,68,68',   text: '#fff' },
    { name: 'Orange',  color: '249,115,22',  text: '#fff' },
    { name: 'Yellow',  color: '255,211,0',   text: '#000' },
    { name: 'Green',   color: '34,197,94',   text: '#fff' },
    { name: 'Teal',    color: '20,184,166',  text: '#fff' },
    { name: 'Cyan',    color: '6,182,212',   text: '#fff' },
    { name: 'Slate',   color: '71,85,105',   text: '#fff' },
    { name: 'Dark',    color: '30,41,59',    text: '#fff' },
  ];
  public activeColor = '0,123,255';

  // Language switcher
  public showLangPicker = false;
  public languages = [
    { code: 'en', label: 'English',  flag: '🇬🇧' },
    { code: 'ms', label: 'Malay',    flag: '🇲🇾' },
    { code: 'cn', label: '中文',      flag: '🇨🇳' },
  ];
  public activeLang = 'en';
  public labels: any = {};

  private i18n: any = {
    en: {
      welcome: 'Welcome back',
      subtitle: 'Sign in to your admin panel',
      username: 'Username',
      usernamePh: 'Enter your username',
      password: 'Password',
      passwordPh: 'Enter your password',
      signIn: 'Sign In',
      footer: '© WinWin88. All Rights Reserved.',
    },
    ms: {
      welcome: 'Selamat kembali',
      subtitle: 'Log masuk ke panel admin anda',
      username: 'Nama Pengguna',
      usernamePh: 'Masukkan nama pengguna',
      password: 'Kata Laluan',
      passwordPh: 'Masukkan kata laluan',
      signIn: 'Log Masuk',
      footer: '© WinWin88. Hak Cipta Terpelihara.',
    },
    cn: {
      welcome: '欢迎回来',
      subtitle: '登录管理面板',
      username: '用户名',
      usernamePh: '请输入用户名',
      password: '密码',
      passwordPh: '请输入密码',
      signIn: '登录',
      footer: '© WinWin88. 版权所有。',
    },
  };

  constructor(private http: HttpService) { }

  ngOnInit(): void {
    // Restore theme
    const savedColor = localStorage.getItem('--theme-color');
    const savedText = localStorage.getItem('--theme-text');
    if (savedColor) {
      this.activeColor = savedColor;
      document.documentElement.style.setProperty('--color', savedColor);
      document.documentElement.style.setProperty('--text', savedText || '#fff');
    }

    // Restore language
    const savedLang = localStorage.getItem('--panel-lang');
    if (savedLang && this.i18n[savedLang]) {
      this.activeLang = savedLang;
    }
    this.labels = this.i18n[this.activeLang];
  }

  async login() {
    this.is_loading = true;
    const y = await this.http.post('/admin/login', this.user);

    if (y) {
      this.http.setAccess(y['uuid'], ['username'], y['name'], y['token'], y['is_admin'], y['is_mario']);
      this.http.navigate(['/lo']);
    }
    this.is_loading = false;
  }

  toggleColorPicker() {
    this.showColorPicker = !this.showColorPicker;
    this.showLangPicker = false;
  }

  applyColor(theme: { color: string, text: string }) {
    this.activeColor = theme.color;
    document.documentElement.style.setProperty('--color', theme.color);
    document.documentElement.style.setProperty('--text', theme.text);
    localStorage.setItem('--theme-color', theme.color);
    localStorage.setItem('--theme-text', theme.text);
    this.showColorPicker = false;
  }

  toggleLangPicker() {
    this.showLangPicker = !this.showLangPicker;
    this.showColorPicker = false;
  }

  applyLang(lang: { code: string }) {
    this.activeLang = lang.code;
    this.labels = this.i18n[lang.code];
    localStorage.setItem('--panel-lang', lang.code);
    this.showLangPicker = false;
  }

  closeDropdowns() {
    this.showColorPicker = false;
    this.showLangPicker = false;
  }
}
